/** @module Camunda/TaskActionColorRenderer */ 
define([
	"dojo/_base/declare",
	"csi/heading/Enum",
	"csi/widget/icon/Util"
], function(declare,Enum,iconUtil) {

	return declare(Enum, {
		/**
		 * @override
		 * Render color rather than the text
		 */
		toHtmlDynamic: function(ctx, h, refNode, params) {
			params.labelType = "html";
			params.labelFunc = function(item, store) {
				const id = store?.idProperty || "id";
				return iconUtil.getTaskActionColorHtml(item[id]);
			};
			return this.inherited(arguments);
		},

		/**
		 * @override
		 * Render color
		 */
		toHtmlStatic: function(ctx, h, refNode, actionData) {
			refNode.innerHTML = iconUtil.getTaskActionColorHtml(ctx.getNode().Color);
			return true;
		},

		/** React */

		/**
		 * @param {context} ctx
		 * @return {string}
		 */
		getReactControlType: function(ctx) {
			return "Camunda/TaskActionColorInlineSelect";
		},

	});
});